import { TFunction } from 'react-i18next';

// Common function for translation.
export type TFunc = TFunction<'translation', undefined>;
